export default "__VITE_ASSET__00bcd2aa__"